import { render, staticRenderFns } from "./AppSignUpAgreePage.vue?vue&type=template&id=84fb7248"
import script from "./AppSignUpAgreePage.vue?vue&type=script&lang=js"
export * from "./AppSignUpAgreePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports